import { Button, styled } from "@mui/material";

const ButtonGradient = styled(Button)(() => ({
    borderRadius: "5px",
    display: "block",
    textTransform: "none",
    backgroundImage: "linear-gradient(90deg, #5da3a5, #518382)"
}));

export default ButtonGradient